module.exports = "<div [class.hidden]=\"!show\">\n    <div class=\"loader-overlay\">\n      <div *ngIf=\"show\" class=\"loader\">dfdsf dsfhdskfds fdsafh dsf dsfh dsfhd fdf</div>\n    </div>\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/auth/loader/loader.component.html
// module id = ./src/app/routes/auth/loader/loader.component.html
// module chunks = main